/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../banking/common';
import '../common/debit_card/debit_card';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "GetCardListRequest": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "owner": {
                        "type": "squareup.banking.Owner",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetCardListResponse": {
                    "fields": {
                      "cards": {
                        "type": "squareup.bbfrontend.common.debit_card.DebitCard",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "sectionLabel": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "orderNewCardLabel": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "allowOrderNewCard": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "informationBannerText": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "cardAssociations": {
                        "type": "squareup.bbfrontend.service.v1.GetCardListResponse.CardAssociation",
                        "id": 6,
                        "rule": "repeated"
                      },
                      "unitTokensEligibleForNewCardOrdering": {
                        "type": "string",
                        "id": 7,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "CardAssociation": {
                        "fields": {
                          "unitToken": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "cardToken": {
                            "type": "string",
                            "id": 1
                          },
                          "cardInvitationToken": {
                            "type": "string",
                            "id": 2
                          }
                        },
                        "nested": {
                          "token": {
                            "oneof": ["cardToken", "cardInvitationToken"]
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetCardListRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetCardListResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetCardListResponse?.nested?.CardAssociation) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetCardListRequest @ squareup/bbfrontend/v1/card_list.proto at 13:1
 */
export const GetCardListRequest = $root.lookupType('squareup.bbfrontend.service.v1.GetCardListRequest');
fixType(GetCardListRequest);
Builder.createAndAttachToType(GetCardListRequest);
/**
 * SOURCE GetCardListResponse @ squareup/bbfrontend/v1/card_list.proto at 21:1
 */
export const GetCardListResponse = $root.lookupType('squareup.bbfrontend.service.v1.GetCardListResponse');
fixType(GetCardListResponse, {
  sectionLabel: {
    notEmpty: true
  },
  orderNewCardLabel: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetCardListResponse);
/**
 * Sometimes we want to know what unit_token a card_token is associated with.
 * This association can be found here.
 *
 * SOURCE CardAssociation @ squareup/bbfrontend/v1/card_list.proto at 36:3
 */
GetCardListResponse.CardAssociation = $root.lookupType('squareup.bbfrontend.service.v1.GetCardListResponse.CardAssociation');
fixType(GetCardListResponse.CardAssociation, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetCardListResponse.CardAssociation);